import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — L-shaped stair. Occupies 2x2 tiles and climbs one storey
// (2.6 m): the first flight runs up along +Z in the west column, a quarter
// landing turns the corner at the north-west tile, and the second flight
// runs up along +X across the north row to reach y = 2.6 at the east edge.
const OAK = "#c8975a";
const OAK_DARK = "#b3814a";

const RISE = 0.325; // per step; 4 + landing + 4 steps = 2.6 total

export const stairsLShaped = defineModel({
  id: "stairs-l-shaped",
  batchId: "modern",
  name: "L-shaped stairs",
  tags: ["modern", "interior", "structure", "stairs"],
  summary: "An L-shaped oak stair with a quarter landing over 2x2 tiles.",
  description:
    "The L-turn stair of the Modern Living kit: 2x2 tiles, climbing one " +
    "storey (2.6 m). The first flight rises along +Z, a quarter landing " +
    "turns the corner, and the second flight rises along +X. Place a floor " +
    "tile at the top as the landing.",
  tiles: { w: 2, h: 2 },
  footprint: 1.8,
  parts(): Part[] {
    const parts: Part[] = [];
    // First flight: 4 steps up along +Z in the west column (x in [-1, 0]).
    for (let i = 0; i < 4; i++) {
      const top = (i + 1) * RISE;
      parts.push({
        geometry: new THREE.BoxGeometry(1.0, top, 0.25),
        color: i % 2 === 0 ? OAK : OAK_DARK,
        position: [-0.5, top / 2, -1 + 0.125 + i * 0.25],
      });
    }
    // Quarter landing at the north-west tile, top at 1.3 (the 5th rise).
    parts.push({
      geometry: new THREE.BoxGeometry(1.0, 1.3, 1.0),
      color: OAK,
      position: [-0.5, 0.65, 0.5],
    });
    // Second flight: 4 steps up along +X across the north row (z in [0, 1]).
    for (let j = 0; j < 4; j++) {
      const top = 1.3 + (j + 1) * RISE;
      parts.push({
        geometry: new THREE.BoxGeometry(0.25, top, 1.0),
        color: j % 2 === 0 ? OAK_DARK : OAK,
        position: [0.125 + j * 0.25, top / 2, 0.5],
      });
    }
    return parts;
  },
  animations: [],
});
